import { ActionTypes } from "../constants/actionTypes";

const initialState = {
    admin_competitors: { data: null, requestInProgress: false, error: null },
    admin_competitor_products: { data: null, requestInProgress: false, error: null },
    admin_resource_types: { data: null, requestInProgress: false, error: null },
    admin_product_types: { data: null, requestInProgress: false, error: null },
    admin_resources: { data: null, requestInProgress: false, error: null },
    admin_single_click_types: { data: null, requestInProgress: false, error: null },
    admin_single_click_type_resources: { data: null, requestInProgress: false, error: null }
};

export function adminDataManager(state = initialState, action) {
    switch (action.type) {
        case ActionTypes.ADMIN_DATA_MANAGER_TABLE_COMPETITORS_REQUEST:
            return { ...state, admin_competitors: { ...state.admin_competitors, requestInProgress: true } };
        case ActionTypes.ADMIN_DATA_MANAGER_TABLE_COMPETITORS_SUCCESS:
            return { ...state, admin_competitors: { data: action.admin_competitors, requestInProgress: false } };
        case ActionTypes.ADMIN_DATA_MANAGER_TABLE_COMPETITORS_FAILURE:
            return { ...state, admin_competitors: { ...state.admin_competitors, requestInProgress: false, error: action.error } };
        case ActionTypes.ADMIN_DATA_MANAGER_TABLE_COMPETITOR_PRODUCTS_REQUEST:
            return { ...state, admin_competitor_products: { ...state.admin_competitor_products, requestInProgress: true } };
        case ActionTypes.ADMIN_DATA_MANAGER_TABLE_COMPETITOR_PRODUCTS_SUCCESS:
            return { ...state, admin_competitor_products: { data: action.admin_competitor_products, requestInProgress: false } };
        case ActionTypes.ADMIN_DATA_MANAGER_TABLE_COMPETITOR_PRODUCTS_FAILURE:
            return { ...state, admin_competitor_products: { ...state.admin_competitor_products, requestInProgress: false, error: action.error } };
        case ActionTypes.ADMIN_DATA_MANAGER_TABLE_RESOURCES_REQUEST:
            return { ...state, admin_resources: { ...state.admin_resources, requestInProgress: true } };
        case ActionTypes.ADMIN_DATA_MANAGER_TABLE_RESOURCES_SUCCESS:
            return { ...state, admin_resources: { data: action.admin_resources, requestInProgress: false } };
        case ActionTypes.ADMIN_DATA_MANAGER_TABLE_RESOURCES_FAILURE:
            return { ...state, admin_resources: { ...state.admin_resources, requestInProgress: false, error: action.error } };
        case ActionTypes.ADMIN_DATA_MANAGER_TABLE_RESOURCES_TYPE_REQUEST:
            return { ...state, admin_resource_types: { ...state.admin_resource_types, requestInProgress: true } };
        case ActionTypes.ADMIN_DATA_MANAGER_TABLE_RESOURCES_TYPE_SUCCESS:
            return { ...state, admin_resource_types: { data: action.admin_resource_types, requestInProgress: false } };
        case ActionTypes.ADMIN_DATA_MANAGER_TABLE_RESOURCES_TYPE_FAILURE:
            return { ...state, admin_resource_types: { ...state.admin_resource_types, requestInProgress: false, error: action.error } };
        case ActionTypes.ADMIN_DATA_MANAGER_COMPETITOR_PRODUCT_TYPES_REQUEST:
            return { ...state, admin_product_types: { ...state.admin_product_types, requestInProgress: true } };
        case ActionTypes.ADMIN_DATA_MANAGER_COMPETITOR_PRODUCT_TYPES_SUCCESS:
            return { ...state, admin_product_types: { data: action.admin_product_types, requestInProgress: false } };
        case ActionTypes.ADMIN_DATA_MANAGER_COMPETITOR_PRODUCT_TYPES_FAILURE:
            return { ...state, admin_product_types: { ...state.admin_product_types, requestInProgress: false, error: action.error } };
        default:
            return state;
    }
}